import GoogleMap from "../utils/map";
import Form from "../modules/form";

const Contacts = {
  init() {
    Form.init();

    const mapEl = $("#map");
    if (mapEl.length) {
      Contacts.renderMap(mapEl);
    }
  },

  events() {
    if ($("select").length) {
      $("select").selectric();
    }
  },

  renderMap(mapEl) {
    const location = {
      lat: mapEl.data("lat"),
      lng: mapEl.data("lng"),
    };

    let zoom = parseInt(mapEl.data("zoom"));
    if (!zoom) {
      zoom = 16;
    }

    const pin = mapEl.data("pin");

    const map_options = {
      zoom,
      center: location,
      disableDefaultUI: true,
      zoomControl: true,
      styles: GoogleMap.styles,
    };

    const map = new google.maps.Map(mapEl[0], map_options);

    map.markers = [];

    const center = new google.maps.LatLng(location.lat, location.lng);

    // Marker and Icon.
    const marker_options = {
      position: center,
      clickable: false,
      map: map,
      animation: google.maps.Animation.DROP,
    };

    if (pin) {
      marker_options.icon = pin;
    } else {
      var icon = {
        size: new google.maps.Size(30, 40),
        path: "M15,40Q30,23.886,30,15.388A15.2,15.2,0,0,0,15,0,15.2,15.2,0,0,0,0,15.388Q0,23.886,15,40Z",
        fillColor: $(".header").css("background-color"),
        fillOpacity: 1,
        anchor: new google.maps.Point(15, 40),
        strokeWeight: 0,
        scale: 1,
      };
      marker_options.icon = icon;
    }

    const marker = new google.maps.Marker(marker_options);

    map.markers.push(marker);
  },
};

export default Contacts;